import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"
import LocaleDetailView from "./LocaleDetailView.jsx"
import { serverErrorKey, failureRemark } from "../../tools/serverErrorKey.js"

import { Modal, Stepper, Button, Group, Text, CloseButton } from '@mantine/core';
import { BRAND_PRIMARY } from "../../theme/brandTheme.js";

class CreateLocaleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeStep: 0,
      tileLength: 0,
      // True between Finish and the server's answer. The Finish button had no
      // in-flight guard, so a double-click sent two inserts and spent two quota
      // units against the one balance this dialog is promising to spend one of.
      isCreating: false,
    };
    autoBind(this);
  }

  changeActiveStep(index) {
    this.setState({ activeStep: index });
    this.state.activeStep = index;
    // The ref can be absent when this runs from componentDidUpdate on open: Mantine's Modal
    // mounts its content via a transition a frame later, so localeDetailView isn't attached
    // yet. Guard it (the LocaleDetailView remounts fresh on open, so its view resets anyway).
    if (this.refs.localeDetailView) {
      this.refs.localeDetailView.changeActiveView(index);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Mantine's Modal has no onEnterTransitionEnd prop, so run the on-open reset here when
    // the dialog transitions from closed to open (otherwise stale state from a previous open
    // leaks into the new session).
    if (this.state.open && !prevState.open) {
      this.handleEnter();
    }
  }

  handleEnter() {
    this.changeActiveStep(0);
    // Reset the LocaleDetailView to ensure clean state
    if (this.refs.localeDetailView) {
      this.refs.localeDetailView.changeActiveView(0);
      this.refs.localeDetailView.resetToDefaults();
    }
  }

  close() {
    this.setState({ open: false, activeStep: 0, isCreating: false });
    this.state.open = false;
    this.state.activeStep = 0;
    this.state.isCreating = false;
    
    // Reset the LocaleDetailView state to defaults when closing
    if (this.refs.localeDetailView) {
      this.refs.localeDetailView.resetToDefaults();
    }
  }

  handleClose() {
    // Check if there are any inputs in any step/view
    const hasAnyInput = this.hasAnyInput();
    
    if (hasAnyInput) {
      let dialogText = {
        title: Localization.strings.UNSAVED_CHANGES,
        content: Localization.strings.UNSAVED_REMINDER,
        confirm: Localization.strings.CONTINUE_EDITING,
        cancel: Localization.strings.DISCARD_CHANGES,
      }
      this.props.root.refs.confirmDialog.show(dialogText, this.closeCancelClicked, this.closeConfirmClicked);
    }
    else {
      this.close();
    }
  }

  // Check if user has entered any input in any UI elements
  hasAnyInput() {
    if (!this.refs.localeDetailView) {
      return false;
    }
    
    const state = this.refs.localeDetailView.state;
    
    // Check if any basic information is filled
    if (state.localeName.trim() !== "" ||
        state.localeDesc.trim() !== "" ||
        state.localeKLA !== -1 ||
        state.localeSubject !== -1 ||
        state.localeCoverFileID !== "" ||
        state.hsRevealCode.trim() !== "") {
      return true;
    }
    
    // Check if map bounds have been changed from default
    const defaultLat = 22.4191;
    const defaultLng = 114.2059;
    if (Math.abs(state.localeCenter.lat - defaultLat) > 0.001 ||
        Math.abs(state.localeCenter.lng - defaultLng) > 0.001) {
      return true;
    }
    
    // Check if any settings have been changed from defaults
    if (state.localeShareable !== false ||
        state.localePublish !== false ||
        state.localeDuplicationAllowed !== 0 ||
        state.hsRevealCodeEnabled !== false ||
        state.localeLanguage !== "tc") {
      return true;
    }
    
    return false;
  }

  handleDone() {
    this.props.parent.refreshLocaleList();
    this.close();
  }

  closeCancelClicked() {

  }

  closeConfirmClicked() {
    this.close();
  }

  handleNext = () => {
    if (this.refs.localeDetailView.validateInput()) {
      let steps = this.props.parent.getSteps();
      let i = this.state.activeStep + 1;
      if (i === steps.length) {
        i = steps.length - 1;
      }
      this.changeActiveStep(i);
    }
  };

  handleBack() {
    let i = this.state.activeStep - 1;
    if (i < 0) {
      i = 0;
    }
    this.changeActiveStep(i);
  };

  handleCancel () {
    this.handleClose();
  }

  handleFinish () {
    if (this.state.isCreating) {
      return;
    }
    if (!this.refs.localeDetailView) {
      return;
    }
    this.refs.localeDetailView.syncLocaleGeometryFromBox();
    // Raised only once the request is actually about to go out. Anything that
    // throws above this line (the two reads dereference a ref) must leave the
    // button as it found it — a flag raised first would disable Finish forever.
    this.setState({ isCreating: true });
    this.state.isCreating = true;
    this.insertLocale();
    // this.props.parent.createMapTile(upperLeft, bottomRight);
  }

  insertLocale() {
    this.refs.localeDetailView.syncLocaleGeometryFromBox();
    let localeDetailViewState = this.refs.localeDetailView.state;
    let requestObj = {
      table: "epack",
      row: {
        name: localeDetailViewState.localeName,
        school_id: this.props.root.getMySchoolId(),
        user_id: this.props.root.getMyUserId(),
        description: localeDetailViewState.localeDesc,
        kla: localeDetailViewState.localeKLA,
        subject: localeDetailViewState.localeSubject,
        color: parseInt(localeDetailViewState.localeColor, 16),
        lang: localeDetailViewState.localeLanguage,
        is_share: (localeDetailViewState.localeShareable? 1 : 0),
        is_ready: (localeDetailViewState.localePublish? 1 : 0),
        is_duplication_allowed: localeDetailViewState.localeDuplicationAllowed,
        mid_lat: localeDetailViewState.localeCenter.lat,
        mid_lon: localeDetailViewState.localeCenter.lng,
        ul_lat: localeDetailViewState.localeUpperLeft.lat,
        ul_lon: localeDetailViewState.localeUpperLeft.lng,
        br_lat: localeDetailViewState.localeBottomRight.lat,
        br_lon: localeDetailViewState.localeBottomRight.lng,
        tn_file_id: localeDetailViewState.localeCoverFileID,
        hs_reveal_code: localeDetailViewState.hsRevealCode,
        hs_reveal_code_enabled: (localeDetailViewState.hsRevealCodeEnabled? 1 : 0),
        is_auto_share_assessment: parseInt(localeDetailViewState.autoShareAssessment, 10) || 0,
        // 0 = Automatically must survive; only an explicit 0 maps to 0, everything else defaults to 1 (Manually)
        is_manual_ai_assessment: (parseInt(localeDetailViewState.manualAiAssessment, 10) === 0 ? 0 : 1),
        // Avatar interaction (game mode)
        is_mood_enabled: (localeDetailViewState.moodEnabled ? 1 : 0),
        is_nudge_enabled: (localeDetailViewState.nudgeEnabled ? 1 : 0),
        is_chat_teacher_to_student: (localeDetailViewState.chatTeacherToStudent ? 1 : 0),
        is_chat_student_to_student: (localeDetailViewState.chatStudentToStudent ? 1 : 0),
        is_chat_student_to_teacher: (localeDetailViewState.chatStudentToTeacher ? 1 : 0)
      }
    }
    this.props.root.refs.API.request("insert", requestObj, this.createLocaleOK, this.createLocaleFail);
  }

  downloadMapTileComplete() {
    this.insertLocale();
  }

  createMapTileDone() {
    this.handleDone();
  }

  finalizeCreateLocale(epackID, linkCoverFailed = false) {
    var requestObj = {epack_id: epackID};
    this.props.root.refs.API.request("touch_epack", requestObj);
    if (linkCoverFailed) {
      this.props.root.addNotification(
        Localization.strings.LOCALE_CREATED_COVER_LINK_FAILED
          || "The LOCALE was created, but its cover image could not be linked to it.",
        false,
      );
    }
    else {
      this.props.root.addNotification(Localization.strings.CREATED, true);
    }
    this.handleDone();
  }

  linkCoverFileToLocale(epackID) {
    const localeDetailViewState = this.refs.localeDetailView ? this.refs.localeDetailView.state : null;
    const coverFileID = localeDetailViewState && localeDetailViewState.localeCoverFileID
      ? parseInt(localeDetailViewState.localeCoverFileID, 10)
      : 0;

    if (!coverFileID) {
      this.finalizeCreateLocale(epackID);
      return;
    }

    const requestObj = {
      table: "file",
      where_field: "id",
      where_value: coverFileID,
      row: {
        epack_id: epackID,
      }
    };
    this.props.root.refs.API.request("update", requestObj, () => {
      this.finalizeCreateLocale(epackID);
    }, (err) => {
      console.log("link cover file to locale failed", err);
      this.finalizeCreateLocale(epackID, true);
    });
  }

  createLocaleOK(res) {
    console.log("createLocaleOK");
    let epackID = res.body['result'];
    // this.props.parent.uploadMapTile(epackID);
    this.linkCoverFileToLocale(epackID);
  }

  createLocaleFail(err) {
    // A refused write (e.g. the server's own 409 when the quota really is
    // exhausted) leaves this dialog OPEN, so Finish has to become pressable
    // again rather than staying stuck mid-submit.
    this.setState({ isCreating: false });
    this.state.isCreating = false;
    // The server's own words go to the CONSOLE. They are English, written for
    // the API contract and the logs — showing them here told a Chinese-UI
    // teacher "locale quota exhausted" seconds after the reminder that names
    // the same rule in their own language. tools/serverErrorKey.js turns the
    // ones worth saying into a localized sentence; anything else falls back to
    // CREATE_FAILED rather than leaking English.
    const key = serverErrorKey(err, 'create');
    console.log("createLocaleFail", failureRemark(err) || err);
    this.props.root.addNotification(
      (key && Localization.strings[key])
        || Localization.strings.CREATE_FAILED
        || "Creation failed.",
      false,
    );
  }

  render() {
    const steps = this.props.parent.getSteps();

    return (
      <Modal
        opened={this.state.open}
        onClose={this.handleClose}
        withCloseButton={false}
        padding={0}
        size="min(1100px, 94vw)"
        radius="md"
        centered
        zIndex={2000}
        styles={{
          content: { height: '85vh', display: 'flex', flexDirection: 'column' },
          body: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', padding: 0 },
        }}
      >
        {/* Brand header */}
        <Group justify="space-between" px="lg" style={{ height: 56, flexShrink: 0, backgroundColor: BRAND_PRIMARY }}>
          <Text c="white" fw={600} fz="lg">{Localization.strings.NEW_LOCALE}</Text>
          <CloseButton onClick={this.handleClose} variant="transparent" c="white" size="lg" />
        </Group>

        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '15px 24px 24px' }}>
          <Stepper active={this.state.activeStep}>
            {steps.map((label, index) => {
              return (
                <Stepper.Step key={label} label={label} />
              );
            })}
          </Stepper>

          <LocaleDetailView
            key="create-locale"
            root={this.props.root}
            parent={this}
            ref="localeDetailView"
            epackID=""
          />
        </div>

        {/* The quota reminder is NOT here any more: it is a confirm step in
            front of this dialog (LocaleViewerBar.confirmQuotaThenCreate), so
            spending a slot is agreed to before any work is done. */}
        <Group justify="flex-end" style={{ padding: '16px 24px', flexShrink: 0, borderTop: '1px solid #e9ecef' }}>
          <If condition={this.state.activeStep === 0}>
            <Then>
              <Button
                variant="default"
                onClick={this.handleCancel}
              >
                {Localization.strings.CANCEL}
              </Button>
            </Then>
            <Else>
              <Button
                variant="default"
                onClick={this.handleBack}
              >
                {Localization.strings.BACK}
              </Button>
            </Else>
          </If>
          <If condition={this.state.activeStep === steps.length - 1}>
            <Then>
              <Button
                onClick={this.handleFinish}
                disabled={this.state.isCreating}
              >
                {Localization.strings.FINISH}
              </Button>
            </Then>
            <Else>
              <Button
                onClick={this.handleNext}
              >
                {Localization.strings.NEXT}
              </Button>
            </Else>
          </If>
        </Group>
      </Modal>
    )
  }
}

export default CreateLocaleDialog;
